import { eclipseServerData } from '@wix/package-picker-shared-eclipse';

export const useFrenchPremiumExperience = () => {
  const { locale, geo } = eclipseServerData.get();
  return locale === 'fr' && geo === 'FR';
};
